export default {
  isEnableABTestQuiz: (state) => {
    if (!state.presentation) return false
    if (state.presentation.userId % 10 > 2) return true
    return false
  },
  isEnableABTestPollSlide: (state) => {
    return (state.slide.type === 'multipleChoice' || state.slide.type === 'imageChoice') &&
            state.presentation && state.presentation.userId % 4 === 2
  },
}
